<template>
  <el-row>
    <template v-for="item in element.list">
      <generate-advanced-item
        v-if="Object.keys(advancedComponents).indexOf(item.type) >= 0"
        :key="item.key"
        :models.sync="commentModel"
        :rules="rules"
        :widget="item"
        :remote="remote"
        :scopeDisabled="disabled"
        :data="data"
      >
      </generate-advanced-item>
      <generate-col-item
        v-else-if="item.type == 'grid'"
        :key="item.key"
        :model.sync="commentModel"
        :rules="rules"
        :data="data"
        :element="item"
        :remote="remote"
        :scopeDisabled="disabled"
        :fromComment="true"
        :commentIndex="commentIndex"
        :commentModel="element.model"
      >
      </generate-col-item>
      <generate-form-item
        v-else
        :key="item.key"
        :models.sync="commentModel"
        :rules="rules"
        :widget="item"
        :remote="remote"
        :data="data"
        :scopeDisabled="disabled"
        :fromComment="true"
        :commentIndex="commentIndex"
        :commentModel="element.model"
      >
      </generate-form-item>
    </template>
  </el-row>
</template>

<script>
import { advancedComponents } from '../advanced/advanced.js'
export default {
  name: 'comment',
  props: [
    'data',
    'element',
    'model',
    'rules',
    'remote',
    'index',
    'disabled',
    'nodeConfig',
    'currentUser',
  ],
  components: {},
  data() {
    return {
      advancedComponents,
      dataModels: this.model,
      commentModel: {},
      commentIndex: this.index,
    }
  },
  created() {
    if (this.commentIndex >= 0) {
      // 只读使用
      this.commentModel = this.dataModels[this.commentIndex]
    } else {
      this.commentIndex = this.dataModels.length
        ? this.dataModels.length - 1
        : this.dataModels.length
      this.renderFormNodeConfig(this.element.list)
    }
  },
  methods: {
    renderFormNodeConfig(list) {
      // 渲染设置流程节点配置项
      if (this.nodeConfig) {
        for (let i = 0; i < list.length; i++) {
          if (list[i].type === 'grid') {
            list[i].columns.forEach(item => {
              if (item.list) this.renderFormNodeConfig(item.list)
            })
          } else if (Object.keys(this.nodeConfig).indexOf(list[i].model) >= 0) {
            // 找到对应字段
            const nodeConfig = this.nodeConfig[list[i].model]
            if (nodeConfig) {
              this.editModule(list[i], nodeConfig)
              const model = list[i].model
              const value = this.currentUser[nodeConfig.initial]
              this.$set(this.commentModel, model, value)
            }
          }
        }
      }
    },
    editModule(moduleObj, obj) {
      if (obj.required !== 'none') {
        // 必填
        let isRequired = false
        if (obj.required === 'true') {
          isRequired = true
          moduleObj.options.required = true
        } else if (obj.required === 'false') {
          moduleObj.options.required = false
        }
        if (moduleObj.rules && moduleObj.rules.length > 0) {
          for (let j = 0; j < moduleObj.rules.length; j++) {
            if (
              Object.prototype.hasOwnProperty.call(
                moduleObj.rules[j],
                'required'
              )
            ) {
              if (!moduleObj.options.required) {
                moduleObj.rules.splice(j, 1)
              } else {
                moduleObj.rules[j].required = true
                moduleObj.rules[j].message = moduleObj.name + '必须填写'
                isRequired = !isRequired
              }
            }
          }
        } else {
          moduleObj.rules = []
        }
        if (isRequired) {
          const rule = {
            required: true,
            message: moduleObj.name + '必须填写',
          }
          moduleObj.rules.push(rule)
        }
      }
      if (obj.disable !== 'none') {
        // 禁用
        if (obj.disable === 'true') {
          moduleObj.options.disabled = true
        } else if (obj.disable === 'false') {
          moduleObj.options.disabled = false
        }
      }

      if (obj.hidden !== 'none') {
        // 隐藏
        if (obj.hidden === 'true') {
          moduleObj.options.hidden = true
        } else if (obj.hidden === 'false') {
          moduleObj.options.hidden = false
        }
      } else {
        moduleObj.options.hidden = false
      }
      // 红色高亮
      if (obj.stress === 'true') {
        moduleObj.options.stress = true
      } else if (obj.stress === 'false') {
        moduleObj.options.stress = false
      }
    },
  },
  watch: {
    commentModel: {
      deep: true,
      handler() {
        this.dataModels.splice(this.commentIndex, 1, this.commentModel)
      },
    },
    dataModels: {
      deep: true,
      handler(val) {
        this.$emit('update:model', val)
      },
    },
  },
  computed: {
    config() {
      return this.data.config
    },
  },
}
</script>
